import { ReactNode } from 'react';
import { Card } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  change?: string;
  changeType?: 'positive' | 'negative' | 'neutral';
  loading?: boolean;
}

export function StatsCard({ title, value, icon, change, changeType = 'neutral', loading }: StatsCardProps) {
  if (loading) {
    return (
      <Card variant="glass" className="p-6">
        <div className="flex items-start justify-between">
          <div className="space-y-3 flex-1">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-32" />
            <Skeleton className="h-3 w-20" />
          </div>
          <Skeleton className="h-12 w-12 rounded-2xl" />
        </div>
      </Card>
    );
  }

  return (
    <Card variant="glass" className="p-6">
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <p className="text-sm font-medium text-surface-500">{title}</p>
          <p className="text-3xl font-bold text-surface-900">{value}</p>
          {change && (
            <p
              className={`text-sm font-medium ${
                changeType === 'positive'
                  ? 'text-green-600'
                  : changeType === 'negative'
                    ? 'text-red-500'
                    : 'text-surface-500'
              }`}
            >
              {change}
            </p>
          )}
        </div>
        <div className="p-3 rounded-2xl bg-primary-50 text-primary-600">{icon}</div>
      </div>
    </Card>
  );
}
